
define('text!templates/strategy_layout.html',[],function () { return '<div class="main-content">\n\t<div class="overlay-view-bg fixposition">\n\t</div>\n    <div class="main-column overlay-view routed-view">\n    </div>\n</div>';});

